<template>
    <div class="bbt-container">
        <div class="bbt-tab bbt-tab--lg" style="margin-top:50px;">
            <ul class="bbt-tab__menu bbt-clearfix">
                <li :class="item.cl" 
                    v-for="(item, index) in postList" 
                    @click="transActiveLine"
                    :key="index">
                    <a href="javascript:;" :class="item.acl">{{item.name}}</a>
                </li>
            </ul>
            <div class="bbt-tab__more"><i class="bbt-icon bbt-icon-more" style="font-size: 24px;"></i></div>
        </div>

        <div>
            <div class="bbt-row">
                <div style="padding-left: 12px; padding-right: 12px;">
                    <section class="bbt-section" style="margin-bottom: 0px;">
                        <div class="bbt-filter">
                            <ul class="bbt-filter__type" @click="filterType">
                                <li class="active">全部
                                </li>
                                <li class="">
                                    <i class="bbt-icon bbt-icon-vote" style="font-size: 20px;"></i>最新
                                </li>
                                <!-- <li class="">
                                    <i class="bbt-icon bbt-icon-debate" style="font-size: 20px;"></i>最热
                                </li>
                                <li class="">
                                    <i class="bbt-icon bbt-icon-debate" style="font-size: 20px;"></i>精华
                                </li> -->
                            </ul>
                            <!-- <ul class="bbt-filter__sort">
                                <li class="">默认</li>
                                <li class="">最新</li>
                                <li class="">最热</li>
                                <li class="active">精华</li>
                            </ul> -->
                            <!-- <el-button type="warning" @click="openSendPost"><i class="el-icon-edit"></i> 发布帖子</el-button>
                            <el-dialog
                                title="发布帖子"
                                :visible.sync="dialogPostVisible"
                                width="50%"
                                @opened="openDialog"
                                :before-close="handleClose">
                                <el-row type="flex">
                                    <el-col :span="10">
                                        <el-input
                                            placeholder="请输入帖子标题"
                                            v-model="postTitle"
                                            clearable>
                                        </el-input>
                                    </el-col>
                                    <el-col :span="10" :offset="1">
                                        <el-select v-model="postCategory" clearable placeholder="请选择分类" @change="selectPost">
                                            <el-option
                                            v-for="item in categoryOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div id="wangEditorSection"></div>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" justify="end">
                                    <el-col :span="3">
                                        <el-button @click="cancelPost">取 消</el-button>
                                    </el-col>
                                    <el-col :span="3">
                                        <el-button type="primary" @click="sendPost">发 帖</el-button>
                                    </el-col>
                                </el-row>
                            </el-dialog> -->
                            <SendPost :direction="direction" />
                        </div>
                        <div style="">
                            <div class="bbt-list">
                                <div class="post-item-wrap" v-for="item in posts" :key="item.id">
                                    <div class="post-item">
                                        <div class="post-item__avatar">
                                            <a href="javascript:;" class="link-dark-major">
                                            <div :style="{backgroundImage: `url(${item.avatar})`}"></div>
                                            </a>
                                        </div>
                                        <div class="post-item__body">
                                            <div class="post-item__info bbt-clearfix">
                                                <h3 class="post-item__title">
                                                    <!-- <a href="/event/377032" class="link-primary font-bold bbt-block" target="_blank">
                                                    {{ item.title }}
                                                    </a> -->
                                                    <router-link :to="{path:'/articleDetail/' + item.id + '?t=p'}" class="link-primary font-bold bbt-block">
                                                        {{ item.title }}
                                                    </router-link>
                                                </h3>
                                            </div>
                                            <div class="post-item__author bbt-clearfix">
                                                <div class="post-item__author-left">
                                                    <a href="javascript:;" class="author_name link-dark-minor">{{ item.userName }}</a>
                                                    <!-- <router-link :to="{path:'/authorDetail/' + item.userId}" target="_blank" class="author_name link-dark-minor">
                                                        {{item.userName}}
                                                    </router-link> -->
                                                    <span class="bbt-dot"></span>
                                                    <span>{{ $filters.formatDate(item.createTime) }}</span>
                                                    <a href="/forum/118" class="coin link-dark-minor">{{ item.categoryName }}</a>
                                                </div>
                                                <!-- <div class="post-item__author-right">
                                                    <span>
                                                        <i class="el-icon-view"></i>&nbsp;51292
                                                    </span>
                                                    <span>
                                                        <i class="el-icon-chat-dot-round"></i>&nbsp;78
                                                    </span>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="post-item-wrap">
                                    <div class="post-item">
                                        <div class="post-item__avatar">
                                            <a href="/user/465710" class="link-dark-major" target="_blank">
                                            <div style="background-image: url(&quot;https://appserversrc.8btc.com/newthread/201903051336541.jpeg&quot;);"></div>
                                            </a>
                                        </div>
                                        <div class="post-item__body">
                                            <div class="post-item__info bbt-clearfix">
                                                <h3 class="post-item__title">
                                                    <a href="/event/364420" class="link-primary font-bold bbt-block" target="_blank"> 应用无界——第二届世界区块链大会（乌镇）
                                                    </a>
                                                </h3>
                                                <span class="post-item__page">
                                                    <div style="display: inline;">
                                                    <a href="/event/364420-2" class="" target="_blank">2</a>
                                                    </div>
                                                </span>
                                                <span class="post-item__tags">
                                                    <i class="bbt-icon bbt-icon-stick-3" title="全局置顶" style="font-size: 20px; color: rgb(130, 160, 28);"></i>
                                                    <i class="bbt-icon bbt-icon-essence-1" title="精华1" style="font-size: 20px; color: rgb(253, 181, 0);"></i>
                                                    <span>活动</span>
                                                    <i class="bbt-icon bbt-icon-bonus" title="帖子被加分" style="font-size: 20px; color: rgb(244, 99, 0);"></i>
                                                    <i class="bbt-icon bbt-icon-hot" title="热度" style="font-size: 20px; color: rgb(253, 181, 0);"></i>
                                                    <i class="bbt-icon bbt-icon-Group" title="活动" style="font-size: 20px; color: rgb(253, 181, 0);"></i>
                                                </span>
                                                <span class="post-item__close">
                                                    <i class="bbt-icon bbt-icon-close" style="font-size: 16px;"></i>
                                                </span>
                                            </div>
                                            <div class="post-item__author bbt-clearfix">
                                                <div class="post-item__author-left">
                                                    <a href="/user/465710" class="author_name link-dark-minor" target="_blank">巴比特APP</a>
                                                    <span class="bbt-dot"></span>
                                                    <time datatime="2019-09-22T04:54:57Z">21 小时前</time>
                                                    <a href="/forum/118" class="coin link-dark-minor">活动/峰会</a>
                                                </div>
                                                <div class="post-item__author-right">
                                                    <span>
                                                        <i class="el-icon-view"></i>&nbsp;339728
                                                    </span>
                                                    <span>
                                                        <i class="el-icon-chat-dot-round"></i>&nbsp;19
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                            <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                                <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                    查看更多
                                </div>
                            </div>
                        </div>
                        <!-- <el-row type="flex" justify="start">
                            <el-col :span="24">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :total="100">
                                </el-pagination>
                            </el-col>
                        </el-row> -->
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { userInfo } from 'os';
import SendPost from '@/post_component/SendPost.vue'
export default {
    name:'PostIndex',
    components:{
        SendPost
    },
    props:{
        serveHost: String
    },
    data() {
        return {
            direction: 'right',
            pagNo:1,
            categoryId:'',
            hasMoreArticle:true,
            posts:[],
            user:{},
            postList:[
                {
                    cl:'active',
                    acl:'router-link-active',
                    name:'最新'
                },
                {
                    cl:'',
                    acl:'',
                    name:'全部'
                }
            ]
        }
    },
    created() {
        // var url = window.location.href;
        // var name = url.split('?')[1];
        // if(name) {
        //     var value = this.categoryName = decodeURIComponent(name.split('=')[1]);
        //     // document.title = value + '  -  马尔比特';
        // }
        this.user = localStorage.getItem('user') == null? {} : JSON.parse(localStorage.getItem('user'));

        const categoryId = this.categoryId = this.$route.params.post_id;

        var _vm = this;
        // 帖子列表
        $.get(_vm.serveHost + "/api/v1/post/list/" + categoryId + "/" + _vm.pagNo, function(r){
            if(r.code != "2000000") {
                console.error('get posts error.');
                return;
            } 
            _vm.posts = r.data;
        });
    },
    methods: {
        openSendPost() {
            this.user = localStorage.getItem('user') == null? {} : JSON.parse(localStorage.getItem('user'));
            if(this.user.userid) {
                if(this.user.postAuth == 1) {
                    this.$message({
                        type:'warning',
                        message:'暂无发帖权限'
                    });
                } else {
                    this.dialogPostVisible = true;
                }
            } else {
                this.$message({
                    type:'warning',
                    message:'请先登录后再试'
                });
            }
        },
        
        transActiveLine:function(event) {
            var _vm = this;
            var eventType = event.target.dataset.type;
            $(event.target).parent().attr('class', 'active').siblings().removeAttr('class');
            switch(eventType) {
                case 'bookList':
                    // $("#bookList").fadeOut(.3);
                    // _vm.loading = true;
                    // setTimeout(function(){
                    //     _vm.loading = false;
                    //     $("#bookList").fadeIn(.3);
                    // },2000)
                break;
                case 'articleList':
                    // _vm.articleType = event.target.dataset.cid;
                    // _vm.hasMoreArticle = false;
                    // _vm.articleLoad = true;
                    // _vm.loadArticleList(_vm, 1, _vm.articleType);
                break;
            }
        },
        filterType:function(event) {
            $(event.target).attr('class', 'active').siblings().removeAttr('class');
        },
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this);
        },
        loadArticleList:function(_vm) {
            // 帖子列表
            $.get(_vm.serveHost + "/api/v1/post/list/" + _vm.categoryId + "/" + _vm.pagNo, function(r){
                if(r.code != "2000000") {
                    console.error('get post list error.');
                }
                console.log(r.data);
                if(r.data) {
                    r.data.forEach((item, index) => {
                        _vm.posts.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    _vm.$alert('没有更多帖子了', '提示', {
                        type:'warning',
                        closeOnClickModal:true,
                        closeOnPressEscape:true,
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
.bbt-btn.bbt-btn--default {
    color: rgba(0,0,0,.88);
    background: #f1f1f1;
    border-color: #f1f1f1;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn-block {
    display: block;
    width: 100%;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.post-item-wrap .post-item__author-right {
    display: inline-block;
    float: right;
}
div a, div span {
    font-weight: 700;
    color: inherit;
    text-decoration: none;
    margin: 0 3px;
    transition: all .3s ease;
}
.post-item-wrap .post-item__tags {
    float: left;
    line-height: 1;
    padding: 1px 0;
}
.post-item-wrap .post-item__tags>i {
    line-height: 22px;
}
.post-item-wrap .post-item__tags>span {
    color: #db5000;
    font-size: 12px;
    line-height: 20px;
    border-radius: 4px;
    border: 1px solid #db5000;
    padding: 0 4px;
}
.post-item-wrap .post-item__close {
    float: right;
    cursor: pointer;
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: #e6e6e6;
    border-radius: 2px;
    line-height: 16px;
    margin: 3px 0;
    text-align: center;
    color: #fff;
    transition: all .3s ease;
}
.post-item-wrap .post-item__author {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.56);
}
.post-item-wrap .post-item__page {
    float: left;
    color: rgba(0,0,0,.56);
    margin: 0 4px;
}
.post-item-wrap .post-item__author-left {
    display: inline-block;
    float: left;
}
.post-item-wrap .post-item__title a:hover {
    color: #db5000;
}

.post-item-wrap .post-item__title a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.post-item-wrap .post-item__avatar {
    float: left;
    width: 42px;
    height: 46px;
}
.post-item-wrap .post-item__avatar a {
    display: block;
    height:46px;
}
.post-item-wrap .post-item__body {
    padding-left: 56px;
    height: 46px;
}
.post-item-wrap .post-item__avatar div {
    width: 42px;
    height: 42px;
    overflow: hidden;
    border-radius: 50%;
    background-size: cover;
    background-position: 50%;
}
.post-item-wrap .post-item__info {
    height: 22px;
}
.post-item-wrap .post-item__title {
    margin: 0;
    font-size: 16px;
    display: inline-block;
    max-width: 420px;
    float: left;
    margin-right: 4px;
}
.post-item-wrap {
    padding: 18px 16px;
    margin: 0 -16px;
    border-radius: 4px;
    position: relative;
    transition: all .3s ease;
}
.bbt-list {
    margin: 0 auto;
    padding-left: 0;
}
.bbt-filter button {
    font-size: 14px;
    float: right;
}
.bbt-btn.bbt-btn--primary {
    color: rgba(0,0,0,.88);
    background: #ffd600;
    border-color: #ffd600;
}
.bbt-btn.bbt-btn--primary {
    color: #fff;
    background: #db5000;
    border-color: #db5000;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.bbt-btn {
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    padding: 9px 15px;
    line-height: 1;
    border: 1px solid transparent;
    background: none;
    border-radius: 4px;
    outline: none;
}
.bbt-filter__sort {
    display: inline-block;
    float: left;
    margin: 9px 0;
    font-weight: 700;
}
.bbt-filter li.active .bbt-icon, .bbt-filter li.active, .bbt-filter li:hover .bbt-icon, .bbt-filter li:hover {
    color: #db5000;
}
.bbt-filter li .bbt-icon {
    position: relative;
    vertical-align: top;
    margin-right: 2px;
    color: #a9a9a9;
    top: 2px;
    font-weight: 400;
}
.bbt-filter li {
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0,0,0,.88);
    margin-right: 24px;
    cursor: pointer;
    transition: all .3s ease;
}
.bbt-filter>ul {
    margin-right: 24px;
}
.bbt-filter__type {
    display: inline-block;
    float: left;
    margin: 9px 0;
    font-weight: 700;
}
.bbt-filter {
    overflow: hidden;
    padding-bottom: 24px;
    padding-top: 8px;
    border-bottom: 1px solid rgba(0,0,0,.08);
}
.bbt-tab__menu>li.active a:after {
    content: "";
    height: 4px;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 2px;
    border-radius: 2px;
    background: #ffd600;
}
.bbt-tab__more {
    color: rgba(0,0,0,.56);
    transition: all .3s ease;
    position: relative;
    white-space: nowrap;
}
.bbt-tab__menu>li.active a, .bbt-tab__menu>li a:hover {
    color: rgba(0,0,0,.88);
}

.bbt-tab__menu>li a {
    color: inherit;
    padding: 7px 0;
    position: relative;
}
.bbt-tab.bbt-tab--lg .bbt-tab__menu>li {
    font-size: 20px;
    line-height: 28px;
    padding: 0;
    position: relative;
}
.bbt-tab__menu>li {
    font-size: 16px;
    line-height: 24px;
    color: rgba(0,0,0,.56);
    float: left;
    list-style: none;
    font-weight: 700;
    transition: all .3s ease;
    width: 8.3333%;
}
.bbt-tab__menu {
    width: 100%;
    position: relative;
}
.bbt-tab {
    margin-bottom: 32px;
    margin-top: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    width: 100%;
    position: relative;
}
</style>